import React from 'react'
import { Col, Row } from 'antd'
import styles from './desc.modules.sass'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import GoogleAdsense from '../Ads/GoogleAdsense'

const DescBlock = ({ data }) => {
  const { t } = useTranslation()
  return (
    <section className={styles.desc}>
      <div className='container'>
        <Row justify='space-between'>
          <Col sm={24} md={14} lg={15} xl={17} className={styles.text_intro}>
            <div className={styles.desc_info}>
              <Row gutter={16}>
                {data.map((d, index) => (
                  <Col xs={24} sm={12} key={index} className={styles.desc_item}>
                    <span className={styles.desc_label}>{d.ext}</span>
                    <h3 className={styles.desc_title}>{d.name}</h3>
                    <div className={styles.desc_text}>{d.description}</div>
                    <Link href='/#'>
                      <a className={styles.desc_link}>{t('audio-converter:more')}</a>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          <Col sm={24} md={10} lg={9} xl={7} className={styles.plan_wrap}>
            <Row className={styles.plan}>
              {/* <Col>
                <div className={styles.plan_heading}>
                  <img src={require('public/images/evano_logo.svg')} alt='logo' />
                  <h2>{t('audio-converter:get_premium')}</h2>
                </div>
                <div className={styles.plan_text}>{t('audio-converter:premium_text')}</div>
              </Col>
              <Col>
                <Link href='/pricing'>
                  <a className={styles.plan_link}>{t('audio-converter:get_premium')}</a>
                </Link>
              </Col> */}
              {/* <ins className="adsbygoogle"
                  style={{display:'block'}}
                  data-ad-client="ca-pub-6022273213615485"
                  data-ad-slot="9798616780"
                  data-ad-format="auto"
                  data-full-width-responsive="true"></ins> */}
              <div style={{height: 300}}>
                <GoogleAdsense
                  className="adsbygoogle"
                  style={{display: 'block', 'width': '300px', 'height': '300px'}}
                  client='ca-pub-6022273213615485'
                  slot="5367210272"
                  format="rectangle"
                  responsive={true} />
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default DescBlock
